import { useState } from "react";
import IconEye from "../../assets/icons/icon_eye.svg";
import IconEyeSlash from "../../assets/icons/icon_eye_slash.svg";
import IconSearch from "../../assets/icons/icon_search.svg";
import "./input.scss";

const Input = (props) => {
    const [isVisible, setIsVisible] = useState(false);
    return (
        <div className={`form-group ${props.label ? "m-1" : ""}`}>
            {
                props.label ? (
                    <label htmlFor={props.id}>
                        {props.label} {props.required && <span style={{ color: 'red' }}>(*)</span>}
                    </label>
                ) : null
            }
            <div className={`${props.type === "password" || props.type === "search" ? "position-relative" : ""}`}>
                {
                    props.type === "search" ? (
                        <img
                            src={IconSearch}
                            className="icon-search"
                            alt="logo search"
                        />
                    ) : null
                }
                <input
                    style={props.style}
                    required={props.required}
                    max={props.max}
                    min={props.min}
                    readOnly={props.isReadOnly}
                    type={props.type === "password" ? (isVisible ? 'text' : 'password') : props.type}
                    className={`form-control ${props.className}`}
                    id={props.id}
                    name={props.id}
                    value={props.value}
                    placeholder={props.placeholder}
                    onChange={props.onChange} 
                />
                {
                    props.type === "password" ? (
                        <img
                            src={isVisible ? IconEye : IconEyeSlash}
                            className="icon-eye pointer"
                            alt="logo eye"
                            onClick={() => setIsVisible(!isVisible)}
                        />
                    ) : null
                }
            </div>
        </div>
    );
}

export default Input;
